import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Slideshow from './components/Slideshow';
import Footer from './components/Footer';
import About from './components/About';
import SummerYouthProgram from './components/SummerYouthProgram';
import Chaperone from './components/Chaperone';
import ContactUs from './components/ContactUs';
import Calendar from './components/Calendar';

// Home page component
const Home = () => (
  <main>
    <section className="hero">
      <div className="hero-content">
        <h1>Youth Supporting Roots</h1>
        <p className="subtitle">Generations Working Together</p>
        <p className="description">
          Youth Supporting Roots is a summer internship program designed to teach people aged 14 to 16 essential skills.
          Participants will help with food pantry distribution and management, gaining practical work experience while
          contributing to their community. This program aims to prepare the next generation of community leaders.
        </p>
      </div>
      <Slideshow />
    </section>
  </main>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/summer-youth-program" element={<SummerYouthProgram />} />
          <Route path="/chaperone" element={<Chaperone />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/calendar" element={<Calendar />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
